import React from 'react';

import { SelectField, useRecordContext } from 'react-admin';

import { get } from 'lodash';

import Answer from '../Answer';

import { industrySectionChoices } from '../../../../constants/industrySections';
import { Languages } from '../../../../constants/languages';
import conflictFields from '../../../../constants/conflictFields';
import applyChoices from '../../applyChoices';
import { IndustryParameters } from '../../questionParameters';

const ValueField = ({
  language,
  extraParameters,
}: {
  language?: Languages;
  extraParameters?: IndustryParameters;
}) => {
  const record = useRecordContext();

  const value = get(record, 'value');
  const sx = get(record, 'sx', {});

  if (!language) return null;

  const choices = applyChoices(
    industrySectionChoices(language),
    extraParameters?.options,
    extraParameters?.choiceLabels,
  );

  return <SelectField choices={choices} record={{ value }} sx={sx} source="value" emptyText="-" fontWeight="bold" />;
};

const Industry = ({ extraParameters }: { extraParameters?: IndustryParameters }) => {
  const record = useRecordContext();

  const language = record?.language as Languages;

  return (
    <Answer
      label={extraParameters?.label ?? 'Industry of the Business'}
      source="industry"
      datapoint={conflictFields.INDUSTRY}
      identificationInfo={undefined}
    >
      <ValueField language={language} extraParameters={extraParameters} />
    </Answer>
  );
};

Industry.ValueField = ValueField;

export default Industry;
